/* eslint-disable no-undef */

import './loginGigya.scss'

import * as api from '../../redux/api/actions.js'
import { loadGigyaScript } from '../../utils/gigyaLoader.js'
import find from 'lodash/find'
import has from 'lodash/has'

import Autocomplete, {
  autocompleteDefaultOnChange,
  autocompleteDefaultOnChangeSavingID,
} from '../../components/material/Autocomplete.js'
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material'
import EulaDialog, {
  COOKIES_BACKEND_IDENTIFIER,
  COOKIES_NAME,
  PRIVACY_BACKEND_IDENTIFIER,
  PRIVACY_NAME,
  USERS_LICENSE_BACKEND_IDENTIFIER,
  USERS_LICENSE_NAME,
} from './eula/EulaDialog'
import React, { Component } from 'react'
import { Navigate } from 'react-router-dom'
import { withRouter } from '../../utils/withRouterCompat'
import { destinoAposLogin } from '../ConviteFazenda/conviteFazendaLogica'
import {
  acceptTerm,
  dismissEula,
  loginWithoutPassword,
  logout,
} from '../../redux/auth/actions.js'
import {
  missingRequiredFieldChecker,
  requiredFieldsEvaluator,
} from '../../utils/formHelper.js'

import { Alert } from '@mui/material'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import { LocalStorageHelper } from '../../utils/localStorageHelper'
import Prompt from '../../components/Prompt.js'
import ZoetisLogo from '../../assets/img/logo_corte.png'
import { connect } from 'react-redux'
import { recordError, recordEvent } from '../../observability/events'
import { textfieldDefaultOnChange } from '../../components/material/TextField.js'

const termsMapping = {
  [COOKIES_BACKEND_IDENTIFIER]: COOKIES_NAME,
  [PRIVACY_BACKEND_IDENTIFIER]: PRIVACY_NAME,
  [USERS_LICENSE_BACKEND_IDENTIFIER]: USERS_LICENSE_NAME,
}

class LoginGigya extends Component {
  constructor(props) {
    super(props)
    this._isMounted = false
    this.state = {
      login: '',
      email: !!LocalStorageHelper.get('GerarNotFoundUser')
        ? JSON.parse(LocalStorageHelper.get('GerarNotFoundUser')).email
        : '',
      userId: !!LocalStorageHelper.get('GerarNotFoundUser')
        ? JSON.parse(LocalStorageHelper.get('GerarNotFoundUser')).userId
        : '',
      password: !!LocalStorageHelper.get('GerarNotFoundUser')
        ? JSON.parse(LocalStorageHelper.get('GerarNotFoundUser')).password
        : '',
      userName: !!LocalStorageHelper.get('GerarNotFoundUser')
        ? JSON.parse(LocalStorageHelper.get('GerarNotFoundUser')).userName
        : '',
      role: '',
      cookiesVersion: null,
      privacyVersion: null,
      usersLicenseVersion: null,
      viewRegisterModal:
        !!LocalStorageHelper.get('GerarNotFoundUser') &&
        !!!LocalStorageHelper.get('GerarTermActive')
          ? true
          : false,
      viewUserDeletedModal: !!LocalStorageHelper.get('GerarUserDeleted')
        ? true
        : false,
      helperGigyaModal: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.onLoginHandler = this.onLoginHandler.bind(this)
    this.onAcceptTerms = this.onAcceptTerms.bind(this)

    this.missingRequiredFieldChecker = missingRequiredFieldChecker.bind(this)
    this.requiredFieldsEvaluator = requiredFieldsEvaluator.bind(this)
    this.autocompleteDefaultOnChange = autocompleteDefaultOnChange.bind(this)
    this.textfieldDefaultOnChange = textfieldDefaultOnChange.bind(this)
    this.autocompleteDefaultOnChangeSavingID =
      autocompleteDefaultOnChangeSavingID.bind(this)
  }

  onGigyaServiceReady() {
    gigya.accounts.showScreenSet({
      screenSet: 'RegistrationLogin',
      startScreen: 'gigya-login-screen',
      lang: 'pt',
      containerID: 'container-gigya-login',
      onSubmit: (event) => {
        // Captura a senha e salva em múltiplos lugares para garantir que não perca
        const password = event.formModel.password

        // 1. Salva no state
        this.setState({ password })

        // 2. Salva no localStorage como backup (será removido após login)
        if (password) {
          localStorage.setItem('GIGYA_TEMP_PASSWORD', password)
        }

        // 3. Registra handler de login
        gigya.socialize.addEventHandlers({
          onLogin: this.onLoginHandler,
        })
      },
      onError: (eventObj) => {
        recordEvent({
          level: 'warn',
          category: 'auth',
          action: 'gigya_login_failed',
          payload: {
            errorCode: eventObj?.errorCode,
            errorMessage: eventObj?.errorMessage,
            errorDetails: eventObj?.errorDetails,
            screen: eventObj?.screen,
          },
        })
      },
    })
  }

  onLoginHandler(eventObj) {
    // Tenta recuperar senha de múltiplas fontes
    let password = this.state.password

    // Se não tem no state, tenta recuperar do localStorage
    if (!password || password === '') {
      const tempPassword = localStorage.getItem('GIGYA_TEMP_PASSWORD')
      if (tempPassword) {
        password = tempPassword
      }
    }

    // Se ainda não tem senha, usa fallback
    if (!password || password === '') {
      password = 'GIGYA_AUTHENTICATED'
    }

    let formatedObj = {
      userId: eventObj.user.UID,
      login: eventObj.user.email,
      password: password,
      tipo: 1,
      helperText: '',
      error: false,
      cookiesVersion: null,
      privacyVersion: null,
      usersLicenseVersion: null,
      name: eventObj.user.firstName + ' ' + eventObj.user.lastName,
    }
    this.setState({
      email: eventObj.user.email || eventObj.profile.email,
      userId: eventObj.user.UID || eventObj.profile.UID,
      userName: eventObj.user.firstName + ' ' + eventObj.user.lastName,
    })

    // Remove senha temporária do localStorage após uso
    localStorage.removeItem('GIGYA_TEMP_PASSWORD')

    recordEvent({
      level: 'info',
      category: 'auth',
      action: 'login_success',
      payload: {
        userId: eventObj.user.UID,
        provider: 'gigya',
      },
    })

    this.props.login(formatedObj)
  }

  async componentDidMount() {
    this.props.logout()
    // Limpa qualquer senha temporária que possa ter sobrado de sessões anteriores
    localStorage.removeItem('GIGYA_TEMP_PASSWORD')
    this._isMounted = true
    try {
      // Carrega o script do Gigya com a chave de login
      await loadGigyaScript(process.env.REACT_APP_LOGIN_GIGYA_API_KEY)
      // Verifica se o componente ainda está montado antes de continuar
      if (this._isMounted) {
        this.onGigyaServiceReady()
      }
    } catch (error) {
      console.error('[LoginGigya] failed to load Gigya script', error)
      recordError(error, {
        category: 'auth',
        action: 'gigya_script_load_failed',
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    // Limpa senha temporária ao sair da página
    localStorage.removeItem('GIGYA_TEMP_PASSWORD')
  }

  handleSubmit() {
    //Setando os valores para usuario => email || cpf
    let valor = this.state.login

    localStorage.setItem(
      'L - ' + new Date(),
      JSON.stringify({ email: this.state.login }),
    )
    // valor = valor.replace('.', '').replace('.', '').replace('-', '');
    this.setState({ login: valor })

    this.props.login({
      login: this.state.email,
      password: this.state.password,
      userId: this.state.userId,
      userName: this.state.userName,
    })

    LocalStorageHelper.remove('GerarTermActive')
    LocalStorageHelper.remove('GerarNotFoundUser')
  }

  async onAcceptTerms() {
    this.props.dismissEula()
    const token = this.props.token
    let success = true
    for (const BACKEND_IDENTIFIER of [
      COOKIES_BACKEND_IDENTIFIER,
      PRIVACY_BACKEND_IDENTIFIER,
      USERS_LICENSE_BACKEND_IDENTIFIER,
    ]) {
      const termAccepted = await this.props.acceptTerm({
        type: BACKEND_IDENTIFIER,
        token,
      })

      if (termAccepted) {
        this.setState({ [termsMapping[BACKEND_IDENTIFIER]]: termAccepted })
      } else {
        success = false
      }
    }
    if (success) {
      this.handleSubmit()
    }
  }

  render() {
    // PG-042: o `from` que o PrivateRoute injeta é honrado SOMENTE quando
    // aponta para a rota de convite — é assim que o `?t=` sobrevive ao login.
    // Para toda outra origem (inclusive `from` ausente) o destino continua
    // sendo '/', exatamente como antes: o login é infraestrutura de 100% dos
    // usuários e o raio de alcance desta mudança precisa ser verificável.
    if (this.props.loggedIn)
      return <Navigate to={destinoAposLogin(this.props.location)} replace />
    if (this.props.showLoading) {
      return (
        <Backdrop open>
          <CircularProgress color='inherit' />
        </Backdrop>
      )
    }

    const rolesOptions = [
      { id: '9c13e4c0-c204-4be7-9381-caa97afb3c3b', name: 'Inseminador' },
      { id: 'a8454122-2d9a-4cea-b610-e76163cd7774', name: 'Veterinário' },
      { id: '92aa6422-c4b3-4d52-aa43-7d5ef7bfa7f1', name: 'Estagiário' },
      {
        id: 'adb7f205-7d82-4b5c-91f8-8e4bc8a6fa3a',
        name: 'Cliente (somente visualização)',
      },
    ]

    return (
      <>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            px: 2,
            py: 4,
          }}
        >
          <Container maxWidth='xs' disableGutters>
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                // boxShadow removido (2026-05-11) — visual mais elegante.
                // Card branco contra o warm-off-white do background já dá
                // contraste suficiente sem precisar de sombra.
                p: { xs: 3, sm: 4 },
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <img
                  src={ZoetisLogo}
                  alt='Zoetis Gerar'
                  style={{ width: 200, maxWidth: '100%' }}
                />
              </Box>

              {this.props.error && (
                <Alert severity='error' sx={{ mb: 2 }}>
                  {this.props.error.title}
                </Alert>
              )}

              <div id='container-gigya-login' className='loginGigya' />
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Typography
                  component='div'
                  sx={{
                    fontSize: '14px',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    color: 'primary.light',
                  }}
                  onClick={() => this.setState({ helperGigyaModal: true })}
                >
                  Está com problemas para fazer o Login?
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>
        <Container disableGutters>
          <EulaDialog
            visible={this.props.shouldAcceptEULA}
            onAccept={this.onAcceptTerms}
          />
        </Container>
        <Prompt
          visible={this.state.helperGigyaModal}
          title='Não perca seu acesso, fique atento às mudanças no seu login!'
          message="Alteramos nosso processo de autenticação. Para não perder o seu acesso ao ProGerar, por favor, clique na opção 'Esqueci minha senha'. Na próxima etapa informe o seu e-mail utilizado no ProGerar, você receberá um e-mail com instruções para inserir a senha nova e utilizá-la daqui pra frente ao entrar na aplicação. Caso tenha dúvidas ou problemas, entre em contato com nossa equipe de atendimento, estaremos à disposição."
          buttons={[
            {
              label: 'Fechar',
              onClick: () => this.setState({ helperGigyaModal: false }),
            },
          ]}
        />
        <Prompt
          visible={this.state.viewRegisterModal}
          title='Parece que você é novo no ProGerar. Por favor, preencha o Perfil para continuar.'
          message={
            <div>
              <div className='p-12 d-4 p-margin-top-2 grid-item'>
                <Autocomplete
                  id='role'
                  label='Perfil'
                  options={rolesOptions}
                  onChange={this.autocompleteDefaultOnChangeSavingID('role')}
                  getOptionLabel={(option) => {
                    if (has(option, 'name')) {
                      return option.name
                    }
                    const opt = find(rolesOptions, { id: option })
                    return (opt && opt.name) || ''
                  }}
                  useDefaultOptionSelected
                  value={this.state.role || ''}
                />
              </div>
            </div>
          }
          buttons={[
            {
              label: 'Cancelar',
              onClick: () => {
                LocalStorageHelper.remove('GerarNotFoundUser')
                this.setState({ viewRegisterModal: false })
              },
            },
            {
              label: 'Salvar',
              onClick: () => {
                // Recupera senha de múltiplas fontes
                let password = this.state.password
                if (!password || password === '') {
                  const tempPassword = localStorage.getItem(
                    'GIGYA_TEMP_PASSWORD',
                  )
                  if (tempPassword) {
                    password = tempPassword
                  }
                }
                if (!password || password === '') {
                  password = 'GIGYA_AUTHENTICATED'
                }

                const payload = {
                  email: this.state.email,
                  password: password,
                  rolesIds: [this.state.role],
                  userId: this.state.userId,
                  userName: this.state.userName,
                }

                this.props.login(payload)
                this.setState({ viewRegisterModal: false })
                LocalStorageHelper.remove('GerarNotFoundUser')
                // Remove senha temporária após uso
                localStorage.removeItem('GIGYA_TEMP_PASSWORD')
              },
            },
          ]}
        />
        <Prompt
          visible={this.state.viewUserDeletedModal}
          title='Usuário excluído'
          message='O seu usuário foi excluído do ProGerar. Por favor, entre em contato com a nossa equipe de atendimento para mais informações.'
          buttons={[
            {
              label: 'Fechar',
              onClick: () => {
                LocalStorageHelper.remove('GerarUserDeleted')
                this.setState({ viewUserDeletedModal: false })
              },
            },
          ]}
        />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (params) =>
      window.location.pathname === '/login' &&
      dispatch(loginWithoutPassword(params)),
    logout: (params) => dispatch(logout()),
    acceptTerm: ({ type, token }) => dispatch(acceptTerm({ type, token })),
    dismissEula: () => dispatch(dismissEula()),
  }
}

const mapStateToProps = (state) => ({
  error: api.getApiError(state, `Authentication/LoginGigya`) || false,
  success: api.getApiResult(state, `Authentication/LoginGigya`) || false,
  loading: api.getApiLoading(state, `Authentication/LoginGigya`),
  showLoading: state.screen.loading,
  loggedIn: state.auth.loggedIn,
  shouldAcceptEULA: state.auth.shouldAcceptEULA,
  token: state.auth.token,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(LoginGigya))
